
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wissen/[slug]",
      function () {
        return require("private-next-pages/wissen/[slug].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wissen/[slug]"])
      });
    }
  